import { Box, Group, Text, Avatar } from '@mantine/core';
import { IconMicrophone, IconMessage } from '@tabler/icons-react';
import type { ConversaMessage as ConversaMessageType } from '@/types/conversa.types';

interface ConversaMessageProps {
  message: ConversaMessageType;
  isOwnMessage?: boolean;
}

export const ConversaMessage = ({ message, isOwnMessage = false }: ConversaMessageProps) => {
  const isTranscription = message.type === 'transcription';

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit',
      second: isTranscription ? '2-digit' : undefined,
    });
  };

  // Icon color: white for own messages (blue background), otherwise standard colors
  const iconColor = isOwnMessage
    ? 'white'
    : isTranscription
      ? 'var(--mantine-color-gray-6)'
      : 'var(--mantine-color-blue-6)';

  const icon = isTranscription ? (
    <IconMicrophone size={14} color={iconColor} />
  ) : (
    <IconMessage size={14} color={iconColor} />
  );

  const avatarColor = isTranscription ? 'gray' : isOwnMessage ? 'blue' : 'gray';
  const bubbleColor = isOwnMessage ? '#228be6' : '#f1f3f5';
  const textColor = isOwnMessage ? 'white' : 'var(--mantine-color-dark-7)';

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: isOwnMessage ? 'row-reverse' : 'row',
        alignItems: 'flex-start',
        gap: 8,
        marginBottom: 12,
      }}
    >
      <Avatar size="sm" color={avatarColor} radius="xl">
        {message.senderName.charAt(0).toUpperCase()}
      </Avatar>

      <Box
        style={{
          maxWidth: '80%',
          backgroundColor: bubbleColor,
          borderRadius: 12,
          padding: '8px 12px',
        }}
      >
        <Group gap={6} mb={4}>
          {icon}
          <Text size="xs" fw={600} c={isOwnMessage ? 'white' : 'dark'}>
            {message.senderName}
          </Text>
          <Text size="xs" c={isOwnMessage ? 'rgba(255,255,255,0.7)' : 'dimmed'}>
            {formatTime(message.timestamp)}
          </Text>
        </Group>
        <Text
          size="sm"
          style={{
            color: textColor,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          }}
        >
          {message.text}
        </Text>
      </Box>
    </Box>
  );
};
